<template>
  <div class='reg-filter'>
    <div id='manageComplianceFilter'>
      <div
        data-toggle="dropdown"
        class="text-right cursor-pointer"
      >
        <span class="dropdown-toggle cursor">
          <span @click="showHideFilter()">
            <img src="/static/images/icons/searchbar_filtermodal_icon.svg"/>
            <span class="filter-header">{{$t('filter')}}</span>
          </span>
        </span>
      </div>
      <div class="dropdown-menu dropdown-menu-left registration-header-filter-ul" :class="{'hide-field': collapsed}">
        <div class="col-xs-12 p-0 filter-card-header">
          <div class="col-xs-12 pb-1 pl-0 pr-0 filter-card-outline">
            <span class="col-xs-12 filter-text pl-0">{{$t('appliedFilters')}}</span>
             <div class="col-xs-12 filter-wrapper p-0">
                            <div class="col-xs-12 column-options-carret-section p-0 filter-options-outline">
                                  <span>
                                  <button data-toggle="collapse" data-target="#collapseManageColumnOptions"
                                  data-parent="#collapseManageColumnOptions" aria-expanded="false">
                                    <img src="/static/images/logos/filter_arrow.svg" class="downCarret">
                                    <img src="/static/images/logos/filter_arrow.svg" class="upCarret">
                                  </button>
                                </span>
                              <div class="filter-options pl-7">{{$t('columnOptions')}}</div>

                            </div>

                            <div class="col-xs-12 p-0 collapse" id="collapseManageColumnOptions">
                              <ul role="menu" v-on:click.stop class="column-options-ul p-0">
                                <li class="col-xs-12 column-name mb-0 p-0" v-for="(cellVal,index) in headers" :key="index">
                                    <div class="col-xs-12 p-0 d-flex">
                                        <div class="col-xs-1 p-0 activityTracker-checkbox">
                                          <span class="checkbox">
                                            <label>
                                              <input type="checkbox"  :value="cellVal" v-model="userSelectableColumns"/>
                                              <span class="cr">
                                                <img class="select-check-box" src="/static/images/icons/select_check.svg" alt="">
                                              </span>
                                            </label>
                                          </span>
                                        </div>
                                        <div class="col-xs-10 pl-3 pr-0 column-options-items-text">
                                          <span
                                          class="vertical-align-sub select-item"
                                          >{{ translate(cellVal) }}</span
                                          >
                                        </div>
                                    </div>
                                </li>
                              </ul>
                            </div>
                          </div>
          </div>
        </div>
        <div class="col-xs-12 footer">
          <button class="footer-btn footer-clear-btn"  @click="resetFilter">{{$t('clearLabel')}}</button>
          <button class="footer-btn footer-apply-btn" @click="applyFilter" >{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
// import { getServiceProviderFiltersData, getDataBasedOnSelectedFilter, getServiceProviderFilteredData } from '../../apis/representationResources';
// import EventBus from '../../utils/event-bus';

export default {
  props: ['selectedColumns'],
  data() {
    return {
      collapsed: true,
      activity_area: [],
      products: [],
      test_and_norms: [],
      selectedActivityArea: {},
      selectedProduct: {},
      selectedTestAndNorms: {},
      payload: {
        activity_area_id: 0,
        filter_level_1: '',
        filter_level_2: '',
        product_id: 0,
        test_and_norm_id: 0,
      },
      userSelectableColumns: [],
      //   collapsed: true,
      headers: [
        'Issue Severity',
        'Issue Type',
        'Resolve Within',
        'Certificate Number',
        'Certificate URL',
        'Product ID',
        'Managed By',
        'Issue Status',
      ],
      triggerWatchInitially: false,
    };
  },
  async created() {
    console.log('sc', this.selectedColumns);
    // this.populateFilters();
  },
  watch: {
    selectedColumns: {
      handler() {
        console.log('selectedColumns', this.selectedColumns);
        if (this.selectedColumns.length) {
          this.triggerWatchInitially = true;
          this.userSelectableColumns = [...this.selectedColumns];
        }
      },
      immediate: true,
    },
    userSelectableColumns: {
      handler(newVal, oldValue) {
        if (this.userSelectableColumns.length) {
          if (this.userSelectableColumns.length > 5 && !this.triggerWatchInitially) {
            this.$nextTick(() => {
              this.userSelectableColumns.splice(5, this.userSelectableColumns.length);
            });
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'English' ? 'Column Limit Exceeded' : 'Limite de coluna excedido',
              text: this.$i18n.locale === 'Portuguese' ? 'Apenas 5 colunas podem ser selecionadas por vez. Desmarque uma coluna atualmente selecionada para selecionar uma nova coluna.' : 'Only 5 columns can be selected at a time. Please deselect a currently selected column to select a new column.',
              group: 'custom-notification',
            });
          }
          if (this.userSelectableColumns.length < 3) {
            const text = this.$i18n.locale === 'Portuguese' ? 'A tabela deve ter no mínimo 3 colunas.' : 'Table should have Min 3 columns.';
            this.$nextTick(() => {
              this.userSelectableColumns = [...oldValue];
            });
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Limite' : 'Limit',
              text,
              group: 'custom-notification',
            });
          }
          // this.$emit('updateColumns', this.userSelectableColumns);
        }
        this.triggerWatchInitially = false;
      },
      immediate: true,
    },

  },
  methods: {
    applyFilter() {
      this.collapsed = !this.collapsed;
      this.$emit('updateColumns', this.userSelectableColumns, this.collapsed);
    },
    convertToStrings(name) {
      switch (name) {
        case 'Issue Severity':
          name = 'issue_severity';
          break;
        case 'Issue Type':
          name = 'issue_type';
          break;
        case 'Resolve Within':
          name = 'resolve_within';
          break;
        case 'Certificate Number':
          name = 'certificate_number';
          break;
        case 'Certificate URL':
          name = 'certificate_url';
          break;
        case 'Product ID':
          name = 'product_id';
          break;
        case 'Managed By':
          name = 'managed_by';
          break;
        case 'Issue Status':
          name = 'issue_status';
          break;
        default:
          name = '';
          break;
      }
      return name;
    },
    translate(name) {
      if (this.$i18n.locale === 'Portuguese') {
        const res = this.convertToStrings(name);
        const data = {
          issue_severity: 'Gravidade do problema',
          issue_type: 'Tipo de problema',
          resolve_within: 'Resolva Dentro',
          certificate_number: 'Número do certificado',
          certificate_url: 'URL do certificado',
          product_id: 'ID do produto',
          managed_by: 'Gerenciado Por',
          issue_status: 'Status do problema',
        };
        return data[res];
      }
      return name;
    },
    showHideFilter(isExpanded = false) {
      this.collapsed = !this.collapsed;
      console.log(isExpanded);
      this.$emit('updateFilterMode', this.collapsed);
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    resetFilter() {
      this.collapsed = !this.collapsed;
      $('#collapseManageColumnOptions').collapse('hide');
      this.userSelectableColumns = [...this.selectedColumns];
      this.$emit('updateColumns', this.userSelectableColumns, this.collapsed);
    },
  },

};
</script>

<style scoped>
.select-item {
font-weight: 400;
font-size: 14px;
line-height: 19px;
color: #4D4D4D;

}
ul li{
  list-style-type: none;
}
.dropdown-menu li {
    padding: 7px 0px 0px 14px;
}
/* .column-name{
  padding-top: 18px;
  padding-left: 36px;
  margin: 0px;
} */
.column-options-ul {
  margin: 0px;
  padding: 0px 0px 0px 36px;
}
/* .column-options-ul li{
  padding-top: 18px;
} */
.pl-9 {
  padding-left: 9px;
}
.pl-7 {
  padding-left: 7px;
}
.pl-3 {
  padding-left: 3px;
}

.pt-25 {
  padding-top: 25px;
}

.pb-18 {
  padding-bottom: 18px;
}

.filter-text-right {
  background: #FFFFFF;
  border-radius: 0px 4px 4px 0px;
  height: 48px;
  padding: 12px 0px 12px 12px;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 10%); */
}

.filter-section {
  font-family: 'Open Sans';
  font-style: normal;
  position: absolute;
  z-index: 3;
  left: 0px;
  top: -5px;
  margin-left: 0px;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 10%); */
}
.filter-card-header {
  background: #FFFFFF;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 10%); */
}

.filter-chevron-section {
  padding: 24px 24px 24px 25px;
}

.filter-compact {
  width: 74px !important;
}
.hide-field {
  display: none !important;
}
.filter-ul {
  /* padding: 16px 16px 16px 24px; */
  width: 296px;
  display: block;
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
  border-radius: 0px;
  border-right: 1px solid rgb(130, 130, 130, 0.4);
  border-left: 0px;
  border-top: 0px;
  border-bottom: 0px;
}

/* .dropdown-menu {
  margin: 0px 0px 0px;
  padding: 0px;
} */

.inside-filter-text {
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #333333;
  padding-left: 16px;
}
.reset-apply-buttons {
  padding: 0px 0px 33px 35px;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.reset-link,
.reset-link:hover,
.reset-link:focus {
  padding: 0px;
  border: none;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #01518a !important;
  background-color: transparent;
}
.filter-wrapper {
  padding-bottom: 44px;
  /* overflow: auto;
  height: 376px; */
}

.column-options-carret-section {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}

.column-options-carret-section button {
  background-color: transparent !important;
  padding: 0px;
  border: none;
}
.column-options-carret-section span button[aria-expanded="true"] img.downCarret {
  display: none;
}

.column-options-carret-section span button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.column-options-carret-section span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
.column-options-carret-section span button img.upCarret {
  display: none;
}
.filter-options-outline {
  padding: 32px 24px 0px 16px;
}
.filter-options,
.filter-options a {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #4D4D4D;
}
.select-check-box {
  height: 17px;
  width: 11px;
  position: absolute;
  left: 3px;
  top: 1px
}
.activityTracker-checkbox>.checkbox .cr {
   border: 2px solid #000000;
  width: 18px;
  height: 18px;
  border-radius: 3px;
}
.activityTracker-checkbox>.checkbox label input[type="checkbox"]:checked+.cr {
 background-color: #01518A;
  /* background-image: url(/static/images/icons/checkbox.svg); */
    /* background-size: 12px 15px;
    background-repeat: no-repeat;
    background-position-x: center; */
    border: none;
}
/* ::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;
  ;
} */
.footer {
  position: absolute;
  bottom: 12px;
  padding: 0px 12px 0px 12px;
  display: flex;
  justify-content: space-between;
}

.filter-header {
  color: #4D4D4D;
  font-size: 14px;
  padding: 3px 16px 0px 9px;
}

.footer-btn {
border-radius: 3px;
font-weight: 600;
font-size: 16px;
line-height: 22px;
border: 1px solid transparent;
padding: 6px 12px;
}

.footer-clear-btn, .footer-clear-btn:hover {
background: #E6E6E6;
color: #404040;
}

.footer-apply-btn, .footer-apply-btn:hover {
background: #01518A;
color: #ffffff;
}

.divider-line {
  border-top: 1px solid #D3D3D3;
  padding: 0px;
  margin: 32px 0px 30px 0px;
}

.plr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.mb-7 {
  margin-bottom: 7px;
}

.service-providers-filter-text {
  font-size: 16px;
  line-height: 22px;
  color: #4D4D4D;
}

.pt-18{
  padding-top: 18px;
}

.filter-card-header {
  background: #FFFFFF;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 10%); */
}

.reg-filter {
  position: absolute;
  z-index: 3;
  /* left: 15px !important;
  margin-left: -20px; */
  top: 14px;
  /* top: 2px; */
  right: 0px;
}

.registration-header-reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: -9px;
  margin-left: -30px;
}

.mt-7 {
  margin-top: 7px;
}

.smart-docs {
  top: unset;
  margin-top: 45px;
}
#manageComplianceFilter {
  height: 52px;
  margin-left: 5px;
}

.reg-dropdown {
  padding: 0px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 0px 4px 4px 0px;
}

.registration-header-reg-dropdown {
  padding: 0px 28px 5px 0px;
}

.registration-header-filter-ul {
  position: relative;
  padding: 0px;
  width: 321px;
  min-height: 786px;
  display: block;
  background: #ffffff;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1); */
  margin-top: 20px !important;
  border-radius: 0px;
  border: 1px solid #B3B3B3;
}

/* ::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;;
} */
.dropdown-menu-left {
  right: auto;
  left: 0px;
  top: -4px;
  margin: 6px 0 0;
}

.filter-text{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  padding-left: 14px;
}
.filter-card-outline {
  padding: 27px 0px 24px 0px;
}

.hide-field {
  display: none !important;
}
</style>
